// Per-page navigation components (power plant nav, year/month selectors, etc.)
import { defineAsyncComponent } from 'vue'

export default {
  GreenTypeNav: defineAsyncComponent(() => import('../green_type_nav.vue')),
  OverviewSortSelector: defineAsyncComponent(
    () => import('../navigation/overview_sort_selector.vue')
  ),
  PowerPlantNav: defineAsyncComponent(
    () => import('../navigation/power_plant_nav.vue')
  ),
  YearMonthNav: defineAsyncComponent(
    () => import('../navigation/year_month_nav.vue')
  )
}
